module.exports = __webpack_public_path__ + "img/V03A.83d911bc.jpg";